export default {
  name: (state) => {
    return (state && state.name) || '';
  },
  apiVersion: (state) => {
    return (state && state.apiVersion) || '';
  }
};
